import { cn } from '@dreamstack/util/src/cn'
import React, { type FunctionComponent } from 'react'

const Square: React.FC<{ color: string; className?: string }> = ({
  color,
  className,
}) => (
  <div
    className={cn('h-px-8 w-px-8 md:h-px-16 md:w-px-16', className)}
    style={{ backgroundColor: color }}
  />
)

const Circle: React.FC<{ color: string; className?: string }> = ({
  color,
  className,
}) => (
  <div
    className={cn(
      'h-px-8 w-px-8 md:h-px-16 md:w-px-16 rounded-full',
      className
    )}
    style={{ backgroundColor: color }}
  />
)

type GraphLegend = {
  legend: string
  color: string
  isCircle?: boolean
}
export const GraphLegends: FunctionComponent<
  React.PropsWithChildren<{
    identifiers: GraphLegend[]
  }>
> = ({ identifiers }) => {
  return (
    <div className="flex flex-wrap justify-start">
      {identifiers.map((p, i) => {
        const color = p.color
        if (!!p.isCircle)
          return (
            <div
              key={i}
              className="flex flex-row items-center py-px-6 px-px-12"
            >
              <Circle color={color} />
              <span className="ml-px-8 text-px-11 md:text-px-16">
                {p.legend}
              </span>
            </div>
          )
        return (
          <div key={i} className="flex flex-row items-center py-px-6 px-px-12">
            <Square color={color} />
            <span className="ml-px-8 text-px-11 md:text-px-16">{p.legend}</span>
          </div>
        )
      })}
    </div>
  )
}
